<h1 class="page-title">Application Counties</h1>
<section class="widget">
    <div class="widget-body">
        <div class="mt">
            <form novalidate [formGroup]="form">
                <div class="display-flex flex-row w-100 mb-3">
                    <input class="form-control w-50 me-2"
                           placeholder="Search by County Name"
                           type="text"
                           [formControl]="nameControl"/>
                    <div class="search-container">
                        <button class="btn btn-primary btn-search" role="button" type="submit"
                                (click)="filterCounties()">Search
                        </button>
                    </div>
                </div>
            </form>

            <table-dynamic id="datatable-table"
                           class="table table-striped table-hover"
                           [headers]="tableHeaders"
                           [currentPage]="currentPage"
                           [totalCount]="totalCount"
                           (headerClick)="sortCounties($event)"
                           (pageChanged)="setPage($event)"
                           (limitChange)="setLimit($event)">
                <tr *ngFor="let county of pagedListOfApplicationCounties?.items">
                    <td class="hidden-sm-down">
                        <a [routerLink]="['../manage-counties', county.id]">
                            <strong>{{county.name}}</strong>
                        </a>
                    </td>
                    <td class="hidden-sm-down">{{ showActiveText(county.isStlWaterActiveInternal) }}</td>
                    <td class="hidden-sm-down">{{ showActiveText(county.isStlWaterActiveExternal) }}</td>
<!--                    <td class="hidden-sm-down">{{ county.stlWaterFundAdministrativePledgeTypeName }}</td>-->
                    <td class="hidden-sm-down">{{ showActiveText(county.isUhonsActiveInternal) }}</td>
                    <td class="hidden-sm-down">{{ showActiveText(county.isUhonsActiveExternal) }}</td>
<!--                    <td class="hidden-sm-down">{{ county.uhonsFundAdministrativePledgeTypeName }}</td>-->
                </tr>
            </table-dynamic>
        </div>
    </div>
</section>
